import { rootApi } from '../rootApi';

export const vehicleRegistrationFormApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllVehicleRegistrationForm: builder.query({
            query: (params) => {
                return {
                    url: 'v1/vehicleregistrationform/getlist',
                    method: 'POST',
                    body: {
                        ...params // filtreleri, arama terimlerini vb. ekle
                    }
                };
            },
            transformResponse: (response) => {
                // response → tüm API yanıtı
                if (response && typeof response === 'object' && response.data && Array.isArray(response.data.items)) {
                    console.log('✅ Extracted items array with', response.data.items.length, 'items');
                    return response.data; // SADECE items dizisini döndür
                }

                console.warn('⚠️ Beklenen yapıda veri gelmedi');
                return [];
            },
            // Keep track of API state for debugging
            onQueryStarted: async (arg, { queryFulfilled }) => {
                try {
                    const result = await queryFulfilled;
                } catch (error) {
                    console.error('getAllVehicleRegistrationForm query error:', error);
                }
            },
            providesTags: ['VehicleRegistrationFormList', 'VehicleRegistrationForm']
        }),
        createVehicleRegistrationForm: builder.mutation({
            query: (data) => ({
                url: 'v1/vehicleregistrationform/add',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['VehicleRegistrationForm']
        }),
        checkChassisNo: builder.query({
            query: (ChassisNo) => ({
                url: 'v1/vehicleregistrationform/checkchassisno',
                method: 'GET',
                params: { ChassisNo }
            }),
            transformResponse: (response) => ({
                isSuccess: response?.isSuccessful,
                errorMessage: response?.errorMessage || '',
                exists: response?.data === true,
                returnMessage: response?.returnUrl || ''
            })
        }),
        updateVehicleRegistrationForm: builder.mutation({
            query: (data) => {
                return {
                    url: 'v1/vehicleregistrationform/update',
                    method: 'POST',
                    body: data
                };
            },
            invalidatesTags: (result, error, arg) => [{ type: 'VehicleRegistrationForm', id: arg.id }]
        }),

        getByIdVehicleRegistrationForm: builder.query({
            query: (id) => {
                return {
                    url: 'v1/vehicleregistrationform/getbyid',
                    method: 'Post',
                    body: {
                        id: id
                    }
                };
            },

            transformResponse: (response) => {
                if (response && typeof response === 'object' && response.data) {
                    return response.data;
                }
                return {};
            },

            onQueryStarted: async (arg, { queryFulfilled }) => {
                try {
                    const result = await queryFulfilled;
                } catch (error) {
                    console.log(error);
                }
            },
            providesTags: (result, error, id) => [{ type: 'VehicleRegistrationForm', id }]
        }),

        deleteVehicleRegistrationForm: builder.mutation({
            query: (id) => {
                return {
                    url: 'v1/vehicleregistrationform/delete',
                    method: 'DELETE',
                    body: { id: id }
                };
            },
            invalidatesTags: ['VehicleRegistrationFormList']
        }),

        changeStatusVehicleRegistrationForm: builder.mutation({
            query: (data) => {
                return {
                    url: 'v1/vehicleregistrationform/changestatus',
                    method: 'POST',
                    body: { id: data.id, returnMessage: data.returnMsg, status: data.status }
                };
            },
            invalidatesTags: ['VehicleRegistrationForm']
        }),

        uploadVehicleRegistrationDocument: builder.mutation({
            query: ({ vehicleRegistrationFormId, file, description }) => {
                const formData = new FormData();
                formData.append('VehicleRegistrationFormId', vehicleRegistrationFormId);
                formData.append('File', file);
                formData.append('Description', description);
                console.log('vehicleRegistrationFormId:', vehicleRegistrationFormId);
                console.log('file:', file);
                console.log('description:', description);
                return {
                    url: 'v1/vehicleregistrationform/uploaddocument',
                    method: 'POST',
                    body: formData
                    // RTK-Query'nin otomatik olarak JSON göndermemesi için 'Content-Type' belirtmiyoruz
                };
            },
            invalidatesTags: ['VehicleRegistrationForm']
        }),
        getDocumentsByVehicleRegistrationFormId: builder.query({
            query: (id) => ({
                url: `v1/vehicleregistrationform/getdocumentsbyid`,
                method: 'GET',
                params: { Id: id }
            }),
            transformResponse: (response) => response?.data || [],
            providesTags: ['VehicleRegistrationForm']
        }),
        updateVehicleRegistrationDocument: builder.mutation({
            query: ({ vehicleRegistrationFormId, documentId, file, description }) => {
                const formData = new FormData();
                formData.append('VehicleRegistrationFormId', vehicleRegistrationFormId);
                formData.append('DocumentId', documentId);
                formData.append('File', file);
                formData.append('Description', description);
                return {
                    url: 'v1/vehicleregistrationform/updatedocument',
                    method: 'POST',
                    body: formData
                };
            },
            invalidatesTags: ['VehicleRegistrationForm']
        }),

        deleteVehicleRegistrationDocument: builder.mutation({
            query: ({ id, documentId }) => ({
                url: 'v1/vehicleregistrationform/deletedocument',
                method: 'DELETE',
                body: { id: id, documentId: documentId }
            }),
            invalidatesTags: ['VehicleRegistrationForm']
        }),
        getChassisListForCVRF: builder.query({
            query: () => ({
                url: 'v1/vehicleregistrationform/getchassisno',
                method: 'GET'
            }),
            transformResponse: (response) => {
                if (response?.data && Array.isArray(response.data)) {
                    return response.data.map((item) => ({
                        id: item.id,
                        chassisNo: item.chassisNo
                    }));
                }
                return [];
            },
            providesTags: ['Chassis'],
            onQueryStarted: async (arg, { queryFulfilled }) => {
                console.log('🚀 getChassisList started');
                try {
                    const result = await queryFulfilled;
                    console.log('✅ Chassis list fetched:', result);
                } catch (error) {
                    console.error('❌ Error fetching chassis list:', error);
                }
            }
        }),

        getVehicleRegistrationFormHistory: builder.query({
            query: ({ id, pageSize = 10, pageNumber = 0, languageId = 1 }) => ({
                url: `v1/vehicleregistrationform/gethistorybyid?Id=${id}&PageSize=${pageSize}&PageNumber=${pageNumber}&LanguageId=${languageId}`,
                method: 'GET'
            }),
            transformResponse: (response) => {
                if (response && response.data && Array.isArray(response.data.items)) {
                    return {
                        items: response.data.items,
                        totalCount: response.data.totalCount
                    };
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: (result, error, { id }) => [{ type: 'VehicleRegistrationForm', id: `history-${id}` }]
        }),
        exportVehicleRegistrationToExcel: builder.query({
            query: (params) => ({
                url: 'v1/vehicleregistrationform/exporttoexcel',
                method: 'POST',
                body: {
                    chassisNo: params.ChassisNo ?? null,
                    plateNumber: params.PlateNumber ?? null,
                    company: params.Company ?? null,
                    country: params.Country ?? null,
                    city: params.City ?? null,
                    status: params.Status ?? null,
                    email: params.Email ?? null,
                    dealerId: params.DealerId ?? null,
                    startDate: params.startDate ?? null,
                    endDate: params.endDate ?? null,
                    LanguageId: params.LanguageId,
                    compressionType: 0
                }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    const { fileBase64, fileName, contentType, recordCount, fileSize, isCompressed, compressionType } = response.data;
                    return { fileBase64, fileName, contentType, recordCount, fileSize, isCompressed, compressionType };
                }
                throw new Error(response?.errorMessage || 'Export failed');
            }
        })
    })
});

export const {
    useGetAllVehicleRegistrationFormQuery,
    useCreateVehicleRegistrationFormMutation,
    useCheckChassisNoQuery,
    useGetByIdVehicleRegistrationFormQuery,
    useUpdateVehicleRegistrationFormMutation,
    useDeleteVehicleRegistrationFormMutation,
    useChangeStatusVehicleRegistrationFormMutation,
    useUploadVehicleRegistrationDocumentMutation,
    useUpdateVehicleRegistrationDocumentMutation,
    useGetDocumentsByVehicleRegistrationFormIdQuery,
    useDeleteVehicleRegistrationDocumentMutation,
    useGetChassisListForCVRFQuery,
    useGetVehicleRegistrationFormHistoryQuery,
    useLazyExportVehicleRegistrationToExcelQuery
} = vehicleRegistrationFormApi;
